module.exports = __webpack_public_path__ + "static/media/text_date.17a4eaa5.svg";